import { plugin, debug } from 'light-component';
import * as Base from '@base';
import { t } from '@common';
import { Require } from '../component';
import styles from './style.module.less';
import type { ReactElement } from 'react';
import type { TextAreaProps } from './types';

export function WidgetTextArea(props: TextAreaProps): ReactElement {
  debug.widget('form textarea', props);
  return (
    <div className={props.className ?? styles.propertyItem}>
      <div className={styles.input}>
        <Require require={props.require} />
        <span className={styles.title}>{t(props.title)}</span>
      </div>
      <div className={styles.input}>
        <Base.Input.TextArea
          autoSize
          onDrop={event => event.preventDefault()}
          placeholder={t(props.textPlaceholder ?? '')}
          disabled={props.readonly}
          value={props.value}
          onChange={({ target }) => props.onChange?.(target.value)}
        />
      </div>
    </div>
  );
}
plugin.register({ kind: 'widget', type: 'textarea', component: WidgetTextArea });

